import { BaseMapper } from '../common/BaseMapper'

import { LineItemAPI, LineItemModel } from './type'

export class LineItemMapper extends BaseMapper {
  apiMapper = (line: LineItemAPI): LineItemModel => ({
    id: line.id,
    price: line.price,
    type: line.type,
    title: line.title,
  })

  public static defaultValue: LineItemModel = {
    id: 0,
    price: 0,
    type: '',
    title: '',
  }
}
